export type TaskColumnKey =
  | "status"
  | "priority"
  | "assignee"
  | "start"
  | "due"
  | "bucket"
  | "scope"
  | "labels"
  | "checklist";

export interface TaskColumnDef {
  key: TaskColumnKey;
  label: string;
  width: number;
  defaultVisible: boolean;
  description?: string;
}

export const TASK_COLUMNS: TaskColumnDef[] = [
  { key: "status", label: "상태", width: 88, defaultVisible: true, description: "진행 상태" },
  { key: "priority", label: "우선순위", width: 72, defaultVisible: true, description: "우선순위" },
  { key: "assignee", label: "담당", width: 76, defaultVisible: true, description: "담당자" },
  { key: "start", label: "시작일", width: 80, defaultVisible: true, description: "시작 날짜" },
  { key: "due", label: "마감일", width: 88, defaultVisible: true, description: "마감 날짜 (목표일)" },
  { key: "bucket", label: "버킷", width: 96, defaultVisible: false, description: "플래너 버킷" },
  { key: "scope", label: "WBS · 작업", width: 200, defaultVisible: false, description: "일정 연동 작업" },
  { key: "labels", label: "라벨", width: 110, defaultVisible: false, description: "태스크 라벨" },
  { key: "checklist", label: "체크리스트", width: 76, defaultVisible: false, description: "체크 항목" },
];

export const DEFAULT_VISIBLE_COLUMNS: TaskColumnKey[] = TASK_COLUMNS
  .filter((c) => c.defaultVisible)
  .map((c) => c.key);

const STORAGE_KEY = "wit:execution-task-columns:v2";
const LEGACY_STORAGE_KEY = "wit:execution-task-columns";

export function loadSavedColumns(): TaskColumnKey[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      const legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
      if (legacy) {
        const parsed = JSON.parse(legacy);
        if (Array.isArray(parsed)) {
          const next = parsed.flatMap((k) => (k === "due" ? ["start", "due"] : [k]));
          const valid = new Set(TASK_COLUMNS.map((c) => c.key));
          const filtered = next.filter((k): k is TaskColumnKey => valid.has(k));
          saveColumns(filtered);
          return filtered;
        }
      }
      return DEFAULT_VISIBLE_COLUMNS;
    }
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.length > 0) {
      const valid = new Set(TASK_COLUMNS.map((c) => c.key));
      const filtered = parsed.filter((k): k is TaskColumnKey => valid.has(k));
      return filtered.length > 0 ? filtered : DEFAULT_VISIBLE_COLUMNS;
    }
  } catch {
    // fallback
  }
  return DEFAULT_VISIBLE_COLUMNS;
}

export function saveColumns(cols: TaskColumnKey[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cols));
  } catch {
    // ignore
  }
}
